// Core
import $ from "jquery";
import "jquery-ui-dist/jquery-ui.structure.css";
import "jquery-ui-dist/jquery-ui.theme.css";
import "../scss/editor.scss";
import "alpinejs";
import Alpine from "alpinejs";
import NavToggle from "./components/NavToggle";
import InView from "./components/InView";
import FullScreenLock from "./components/FullScreenLock";
import Home from "./components/Home";
import ContainerSpacingHelpers from "./components/ContainerSpacingHelpers";
import FormHelpers from "./components/FormHelpers";
import Slider from "./components/Slider";
import Sticky from "./components/Sticky";
import VerticalAccordion from "./components/VerticalAccordion";
import AccordionAnimation from "./components/AccordionAnimation";
import "./components/QuickExit";
window.jQuery = window.$ = $;
// CustomDropdown()
// window.CustomDropdown = CustomDropdown
// Alpine.data('CustomDropdown', CustomDropdown);
// Alpine.start();
document.addEventListener("alpine:init", () => {
    Alpine.data("dropdown", () => CustomDropdown);
});
(async function () {
    await import("jquery-ui-dist/jquery-ui");
    const delayExecution = APP.isDevLocal ? 1000 : 1;
    setTimeout(function () {
        Home();
        InView.init();
        NavToggle.init();
        FullScreenLock.init();
        // ClickOutside.init()
        ContainerSpacingHelpers.init();
        FormHelpers();
        Sticky();
        FullScreenLock.init();
        VerticalAccordion();
        AccordionAnimation();
        Slider.init();
    }, delayExecution);
})();
